import React, { useState } from "react";
import { Select, MenuItem } from "@mui/material";
import banner from "../../../../assets/new-images/banner_5_contact-us.png";
import PageBanner from "../../../../common/components/PageBanner";
import getItTouch from "../../../../assets/getInTouch_pic.png";
import email from "../../../../assets/icons/email_icon.svg";
import phone from "../../../../assets/icons/phone_icon.svg";
import location from "../../../../assets/icons/location_icon.svg";
import { styled } from "@mui/material/styles";
import Alert from '@mui/material/Alert';
import "../styles/Aboutus.css"
import { sendContactUsMessage } from "../redux/actions";

// TODO(refresh): MYREDFOLDER, Inc. still has to confirm which team receives each
// inquiry type. Until then the type is sent as a subject prefix so staff can sort.
const INQUIRY_TYPES = [
  "Account and subscription support",
  "Organizational programs and training",
  "Privacy or security questions",
  "Something else",
];

const MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=255+Primera+Blvd+Ste+160+Lake+Mary+FL+32746";

const ContactUsComponent = () => {

  const Img = styled("img")({
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  });

  const [formData, setFormData] = useState({
    inquiryType: INQUIRY_TYPES[0],
    name: '',
    emailId: '',
    subject: '',
    message: '',
  });

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const validateName = (name) => {
    const nameRegex = /^[a-zA-Z\s']+$/;
    return nameRegex.test(name);
  };

  const validateEmail = (email) => {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(email);
  };


  const handleSubmit = (event) => {
    event.preventDefault();

    const isNameValid = validateName(formData.name);
    const isEmailValid = validateEmail(formData.emailId);

    if (formData.name.trim() === "" || formData.emailId.trim() === "") {
      if (formData.name.trim() === "") setNameError('This is required');
      if (formData.emailId.trim() === "") setEmailError('This is required');
      return;
    }
    // else if (!isNameValid) {
    //   setNameError('Please enter a valid name.');
    //   return;
    // }

    else if (!isEmailValid) {
      setEmailError('Please enter a valid email address');
      return;
    }
  

// window.scrollTo(0,0)
//       setSuccessMessage('Message Sent Successfully! Our Team will reach you shortly');
//       setTimeout(() => {
//         setSuccessMessage('');
//       }, 5000);
//       event.target.reset();
    

    const { inquiryType, ...message } = formData;
    setSubmitting(true);
    sendContactUsMessage({
      ...message,
      subject: `[${inquiryType}] ${message.subject}`.trim(),
    })
      .then((apiData) => {
        if (apiData && apiData.status === 200) {
          setErrorMessage('');
    window.scrollTo(0,0)
          setSuccessMessage('Message Sent Successfully! Our Team will reach you shortly');
          setTimeout(() => {
            setSuccessMessage('');
          }, 5000);
          setFormData({ inquiryType: INQUIRY_TYPES[0], name: '', emailId: '', subject: '', message: '' });
        }
        if (apiData && apiData.status !== 200) {
          setSuccessMessage('')
          setErrorMessage(apiData.message);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setErrorMessage('Something went wrong. Please try again.');
      })
      .finally(() => setSubmitting(false));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'name') {
      setNameError('')
    } else if (name === 'emailId') {
      setEmailError('')
    }
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  return (
    <div>
      <PageBanner
        image={banner}
        alt="A MYREDFOLDER support specialist wearing a headset, ready to help by phone."
        eyebrow="About Us / Contact Us"
        title="Contact Us"
      />
      <div className="container-aboutus-contactus">
        <div className="mrf-contact">
          <aside className="mrf-contact__aside" aria-labelledby="contact-details-title">
            <h2 id="contact-details-title" className="mrf-contact__title">Our contact details</h2>
            <figure className="mrf-contact__map">
              <a
                href={MAP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open 255 Primera Blvd., Lake Mary, Florida in Google Maps (opens in a new tab)"
              >
                <img
                  src={getItTouch}
                  alt="Map showing 255 Primera Blvd., Lake Mary, Florida."
                  className="mrf-contact__map-img"
                  loading="lazy"
                />
              </a>
              <figcaption className="mrf-contact__map-cta">
                <a href={MAP_URL} target="_blank" rel="noopener noreferrer">
                  Get directions
                  <span className="sr-only"> (opens in a new tab)</span>
                </a>
              </figcaption>
            </figure>
            <ul className="mrf-contact__list">
              <li className="mrf-contact__item">
                <span className="mrf-contact__icon"><img src={location} alt="" /></span>
                <div>
                  <span className="mrf-contact__label">Address</span>
                  <p className="mrf-contact__value">
                      255 Primera Blvd. Ste, 160 Lake Mary, FL 32746
                  </p>
                </div>
              </li>
              <li className="mrf-contact__item">
                <span className="mrf-contact__icon"><img src={phone} alt="" /></span>
                <div>
                  <span className="mrf-contact__label">Phone</span>
                  <a href="tel:+18882679990" className="mrf-contact__value mrf-contact__link">
                      + (888) 267 9990
                  </a>
                </div>
              </li>
              <li className="mrf-contact__item">
                <span className="mrf-contact__icon"><img src={email} alt="" /></span>
                <div>
                  <span className="mrf-contact__label">Email</span>
                  <a
                      href="mailto:info@nepta.us"
                    className="mrf-contact__value mrf-contact__link"
                  >
                      info@nepta.us
                  </a>
                </div>
              </li>
            </ul>
          </aside>

          <section className="mrf-contact__card" aria-labelledby="contact-form-title">
            <h2 id="contact-form-title" className="mrf-contact__title">How can we help?</h2>
            <p className="mrf-contact__intro">
              Choose a topic and tell us how we can help. Fields marked <span className="required-asterisk" aria-hidden="true">*</span> are required.
            </p>

            {successMessage && (
              <Alert severity="success" className="mrf-contact__alert">{successMessage}</Alert>
            )}
            {errorMessage && (
              <Alert severity="error" className="mrf-contact__alert">{errorMessage}</Alert>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className="mrf-contact__field">
                <label id="contact-inquiry-label">What is your question about?</label>
                <Select
                  labelId="contact-inquiry-label"
                  id="contact-inquiry-type"
                  name="inquiryType"
                  fullWidth
                  className="mrf-contact__select"
                  value={formData.inquiryType}
                  onChange={handleChange}
                  MenuProps={{ PaperProps: { className: "mrf-contact__menu" } }}
                >
                  {INQUIRY_TYPES.map((type) => (
                    <MenuItem key={type} value={type}>{type}</MenuItem>
                  ))}
                </Select>
              </div>

              <div className="mrf-contact__row">
                <div className="mrf-contact__field">
                  <label htmlFor="contact-name">
                    Name<span className="required-asterisk" aria-hidden="true">*</span>
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    autoComplete="name"
                    required
                    value={formData.name}
                    aria-invalid={nameError !== ""}
                    aria-describedby={nameError ? "contact-name-error" : undefined}
                    className={`mrf-contact__control ${nameError ? "is-invalid" : ""}`}
                    onChange={handleChange}
                  />
                  {nameError && <p id="contact-name-error" className="mrf-contact__error" role="alert">{nameError}</p>}
                </div>
                <div className="mrf-contact__field">
                  <label htmlFor="contact-email">
                    E-mail<span className="required-asterisk" aria-hidden="true">*</span>
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="emailId"
                    autoComplete="email"
                    required
                    value={formData.emailId}
                    aria-invalid={emailError !== ""}
                    aria-describedby={emailError ? "contact-email-error" : undefined}
                    className={`mrf-contact__control ${emailError ? "is-invalid" : ""}`}
                    onChange={handleChange}
                  />
                  {emailError && <p id="contact-email-error" className="mrf-contact__error" role="alert">{emailError}</p>}
                </div>
              </div>

              <div className="mrf-contact__field">
                <label htmlFor="contact-subject">Subject</label>
                <input
                  type="text"
                  id="contact-subject"
                  name="subject"
                  value={formData.subject}
                  className="mrf-contact__control"
                  onChange={handleChange}
                />
              </div>

              <div className="mrf-contact__field">
                <label htmlFor="text-contact">Message</label>
                <textarea
                  name="message"
                  id="text-contact"
                  rows={5}
                  value={formData.message}
                  className="mrf-contact__control"
                  onChange={handleChange}
                />
              </div>

              <p className="mrf-notice">
                Please do not include passwords, medical records, or other sensitive information in this form.
              </p>

              <button type="submit" className="mrf-contact__submit" disabled={submitting}>
                {submitting ? "Sending…" : "Send Message"}
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ContactUsComponent;